import * as React from 'react'
import { useFormContext } from 'react-hook-form'

import {
  FieldElementWrapperProps,
  FieldWrapper
} from '~/components/field-wrapper/FieldWrapper'
import { useFieldError } from '~/components/form/useFieldError'
import { useFormCustomContext } from '~/components/form/useFormCustomContext'
import {
  SearchInput,
  SearchInputProps
} from '~/components/search-input/SearchInput'

type SearchFieldProps = SearchInputProps & FieldElementWrapperProps

export const SearchField = ({
  className,
  hideLabel,
  label,
  name,
  validation,
  prompt,
  description,
  appearance,
  theme,
  ...remainingProps
}: SearchFieldProps) => {
  const { register } = useFormContext()
  const context = useFormCustomContext()
  const { error } = useFieldError(name)

  const ref = validation ? register(validation) : register
  const formAppearance = context?.appearance || appearance
  const formTheme = context?.theme ?? theme

  return (
    <FieldWrapper
      className={className}
      description={description}
      error={error}
      fieldId={name}
      hideLabel={hideLabel}
      label={label}
      prompt={prompt}
      required={Boolean(validation?.required)}
      appearance={formAppearance}
    >
      <SearchInput
        id={name}
        name={name}
        ref={ref}
        appearance={formAppearance}
        theme={formTheme}
        {...(error && { state: 'error' })}
        {...remainingProps}
      />
    </FieldWrapper>
  )
}

SearchField.displayName = 'SearchField'
